import ng from 'angular';
import { IGastroOptionsModel, IGastronomicProposalModel } from '../../../../models/gastronomic-proposal.model';
import { MmBDatalayerUtilsService } from '@src/components/services/ib-MmB-datalayer/services/ib-MmB-datalayer-utils-service';
import { MMBDatalayerConstants } from '@src/components/services/ib-MmB-datalayer/constants/ib-MmB-datalayer-constants';
import { MmBAppConstants } from '@src/ib-MmB-constants';
import { DIGITAL_MENU_CONSTANTS, GASTRONOMIC_PROPOSAL_CONSTANTS } from '../../../../constants/gastronomic-proposal-constants';
import { IbGastronomicProposalUtilsService } from '@src/components/ib-MmB-gastronomic-proposal/services/ib-gastronomic-proposal-utils.service';
import { IbDigitalMenuService } from '@src/components/ib-MmB-gastronomic-proposal/services/ib-digital-menu.service';
import { IbSpecialMealsService } from '@src/components/ib-MmB-gastronomic-proposal/services/ib-special-meals.service';
@Component('ib-MmB-gastronomic-proposal-module', 'ibGastronomicOptions', {
    bindings: {
        gastroProposalModel: '<'
    },
    controller: GastronomicProposalOptionsComponent,
    controllerAs: 'gastronomicOptionsCtrl',
    templateUrl: ['MmBAppConstants', function (MmBAppConstants) {
        return MmBAppConstants.templatesRoute + 'ib-gastronomic-proposal-options-view.html';
    }]
},
    ['$window', 'CommonsModalService', 'localStorageService', 'MmBDatalayerUtilsService', 'IbGastronomicProposalUtilsService', 'IbDigitalMenuService', 'IbSpecialMealsService', '$rootScope'], [])
export class GastronomicProposalOptionsComponent implements ng.IController {

    gastroProposalModel: IGastronomicProposalModel;
    model: IGastroOptionsModel = {
        flightIndexSelected: 0,
        indextOtherTab: 0,
        otherTabSelected: false,
        isMobile: false,
        flightTabs: [],
        otherFlightTabs: [],
        flightSelected: null
    };
    maxDateAvailables = DIGITAL_MENU_CONSTANTS.MAX_DATES_AVAILABLE;
    constructor(
        private $window: ng.IWindowService,
        private commonsModalService: CommonsModalService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private MmBDatalayerUtilsService: MmBDatalayerUtilsService,
        private ibGastronomicProposalUtils: IbGastronomicProposalUtilsService,
        private ibDigitalMenuService: IbDigitalMenuService,
        private ibSpecialMealsService: IbSpecialMealsService,
        private $rootScope
    ) {
        this.ibGastronomicProposalUtils.menusSelected$.subscribe((response: number) => {
            this.gastroProposalModel.specialMealNumSelected = response
            this.updateMenusSelected();
        });
        this.ibGastronomicProposalUtils.updateDatalayerOption$
            .subscribe(type => this.updateDatalayer(GASTRONOMIC_PROPOSAL_CONSTANTS.DATALAYER_INTERACTION_TYPE.INTERACTION, true, type));
        this.ibGastronomicProposalUtils.nextFlightOptions$.subscribe(() => this.goToNextFlight())
    }

    activate(): void {
        this.updateFlightsModel();
        this.upadteIsMobile();
        this.initSelectedFlight();
        ng.element(this.$window).on('resize', () => {
            this.updateFlightsModel();
            this.upadteIsMobile();
        });

        this.updateDatalayer(GASTRONOMIC_PROPOSAL_CONSTANTS.DATALAYER_INTERACTION_TYPE.INTERACTION, false);
        this.updateDatalayerWithOptions();
    };

    trunc(text) {
        const maxLength = this.model.otherFlightTabs.length > 0 ? (this.model.flightTabs.length === 2 ? 8 : 8) : (this.model.flightTabs.length === 1 ? 20 : 8);
        if (text.length > maxLength) {
            return text.slice(0, (maxLength - 3)) + '...';
        } else {
            return text;
        }
    }

    selectFlightTabs(index) {
        this.model.flightIndexSelected = index;
        this.model.indextOtherTab = 0;
        this.model.otherTabSelected = false;
        this.model.flightSelected = this.model.flightTabs[index];
        this.emitFlightTabSelected();
        this.updateDatalayer(GASTRONOMIC_PROPOSAL_CONSTANTS.DATALAYER_INTERACTION_TYPE.INTERACTION, false);
        this.updateDatalayerWithOptions();
    }

    selectOtherFlightTabs(index) {
        this.model.flightIndexSelected = 2;
        this.model.indextOtherTab = index;
        this.model.otherTabSelected = true;
        this.model.flightSelected = this.model.otherFlightTabs[index];
        this.emitFlightTabSelected();
        this.updateDatalayer(GASTRONOMIC_PROPOSAL_CONSTANTS.DATALAYER_INTERACTION_TYPE.INTERACTION, false);
        this.updateDatalayerWithOptions();
    }

    executeCommand(option: any) {
        switch (option.type) {
            case 'PREORDER':
                this.redirectToLanding();
                break;
            case 'SPECIAL_MEALS':
                this.openSpecialMeals();
                break;
            case 'ONBOARD_MENU':
            case 'DIGITAL_MENU':
                window.open(option.link, '_blank').focus();
                break;
            default:
                this.openPreSelectionModal();
                break;
        }
        this.updateDatalayer(GASTRONOMIC_PROPOSAL_CONSTANTS.DATALAYER_INTERACTION_TYPE.INTERACTION, true, option.type);
    }

    openPreSelectionModal() {
        const modelObject = {};
        this.commonsModalService.showGenericDynamicModal(
            false,
            'ib-pre-selection-modal-view.html',
            modelObject,
            'IbPreSelectionModalController',
            'ib-modals ib-modals--right ib-modals--full-mobile fade'
        );
    }

    redirectToLanding() {
        //method to redirection to preorder
        const pnr = this.localStorageService.get('PNR');
        const surname = this.localStorageService.get('checkinSurname');
        let language= this.$rootScope.appLang;
        let lang = 'en';
        switch (language) {
            case 'ca':
                lang = 'es';
                break;
            case 'ja':
            case 'zh':
            case 'nl':
            case 'ru':
                lang = 'en';
                break;
            default: lang = language;
                break;
        }
        const toRedirect = `https://pre-order.iberia.com/landing/?locator=${pnr}&surname=${surname}&language=${lang}`;
        this.$window.open(toRedirect, '_blank');
    }

    openPDFMenu(url: string) {
        this.$window.open(url, '_blank');
    }

    isLastFlight(): boolean {
        const position = this.getFlightPosition();
        return position < (this.gastroProposalModel.flights.length - 1);
    }

    /**
    * This method is executed by subscription and change tab selected.
    * This method check the index of flight selected to change next tab.
    * Depend of the index execute selectOtherFlightTabs() or selectFlightTabs();
    **/
    goToNextFlight() {
        const flightPosition = this.getFlightPosition();
        const hasOtherTabs = this.model.otherFlightTabs.length > 0;
        if (hasOtherTabs && (flightPosition >= 1 || this.model.flightTabs.length === 1)) {
            const otherTabNextFlight = this.model.otherTabSelected ? (this.model.indextOtherTab + 1) : this.model.indextOtherTab;
            this.selectOtherFlightTabs(otherTabNextFlight);
        } else {
            this.selectFlightTabs(flightPosition + 1);
        }
    }

    isTLVEconomy(): boolean {
        const { flightSelected } = this.model;
        return (flightSelected.arrival.code === "TLV" || flightSelected.departure.code === "TLV") && flightSelected.cabin.type === "ECONOMY"
    }

    showNotAirlineAvailableMessage(): boolean {
        const { flightSelected } = this.model;
        const case1 = !flightSelected.airlineAvailable;
        //Show message when Airline is operate by (IB, I2, YW) and have emptyOptions and  flight dont flown and departureDate is <12 days
        const case2 = flightSelected.airlineAvailable && flightSelected.gastronomicOptions.length === 0 && !flightSelected.showFlownMessage && !flightSelected.showLongTermWarning;
        return case1 || case2;
    }

    flightHaveSpecialMeals(): boolean {
        return this.gastroProposalModel.specialMealNumSelected > 0;
    }

    private getFlightPosition(): number {
        return this.gastroProposalModel.flights.findIndex(slice => this.model.flightSelected.id === slice.id);
    }

    private openSpecialMeals() {
        this.ibGastronomicProposalUtils.openSpecialMeals();
    }

    private initSelectedFlight() {
        this.model.flightSelected = this.model.flightTabs[0];
        this.emitFlightTabSelected();
    }
    /*
      * This method init the flights data model regarding quantity of flights.
      * If the booking have more than 3 or 2 (in resolution < 768px) segments we show otherFlightsTab
    */
    private updateFlightsModel() {
        const width = this.$window.innerWidth;
        if (width >= 768) {
            if (this.areFlightsExtensive()) {
                this.model.flightTabs = this.gastroProposalModel.flights.slice(0, 2);
                this.model.otherFlightTabs = this.gastroProposalModel.flights.slice(2);
            } else {
                this.model.flightTabs = this.gastroProposalModel.flights.slice(0);
                this.model.otherFlightTabs = [];
            }
        } else {
            if (this.areFlightsExtensiveInMobile()) {
                this.model.flightTabs = this.gastroProposalModel.flights.slice(0, 1);
                this.model.otherFlightTabs = this.gastroProposalModel.flights.slice(1);
            } else {
                this.model.flightTabs = this.gastroProposalModel.flights.slice(0);
            }
        }

    }

    private upadteIsMobile() {
        this.model.isMobile = this.$window.innerWidth < 480 ? true : false;
    }

    private areFlightsExtensive() {
        return this.gastroProposalModel.flights.length > 3;
    }
    private areFlightsExtensiveInMobile() {
        return this.gastroProposalModel.flights.length > 2;
    }

    private updateDatalayerWithOptions() {
        this.model.flightSelected?.gastronomicOptions.forEach(option => {
            this.updateDatalayer(GASTRONOMIC_PROPOSAL_CONSTANTS.DATALAYER_INTERACTION_TYPE.IMPRESSION, true, option.type);
        });
    }

    private updateDatalayer(event: string, optionSelected = false, optionType?: string) {
        const quadrigam = MmBAppConstants.QUADRIGAM.MODAL_GASTRONOMIC_PROPOSAL;
        const eventAction = (event === GASTRONOMIC_PROPOSAL_CONSTANTS.DATALAYER_INTERACTION_TYPE.IMPRESSION) ? MMBDatalayerConstants.DATALAYER_EVENT_TYPES.IMPRESSIONS : MMBDatalayerConstants.DATALAYER_EVENT_TYPES.CLIC;
        const eventLabel = this.getEventLabel(optionSelected, optionType);

        this.MmBDatalayerUtilsService.updateDatalayerEvents(MMBDatalayerConstants.GASTRONOMIC_EVENT_CATEGORY_VALUES.GASTRONOMIC_PROPOSAL, eventAction, eventLabel, MMBDatalayerConstants.DatalayerGeneralConstants.EVENT_NAME_INTERACTION);
        this.MmBDatalayerUtilsService.setProcessAndStep(MMBDatalayerConstants.DIGITAL_DATA_PROCESS[quadrigam], MMBDatalayerConstants.GASTRONOMIC_DIGITAL_DATA_STEPS[optionType], quadrigam, false);
    }

    private getEventLabel(optionSelected: boolean, optionType?: string): string {
        const { departure, arrival } = this.model.flightSelected ? this.model.flightSelected : { departure: { code: '' }, arrival: { code: '' } };
        const { GASTRONOMIC_EVENT_LABEL_VALUES } = MMBDatalayerConstants;
        let eventLabel = `${GASTRONOMIC_EVENT_LABEL_VALUES.TAB_FLIGHT}:${departure.code}|${arrival.code}`;

        if (this.model.otherTabSelected) {
            eventLabel += `|${GASTRONOMIC_EVENT_LABEL_VALUES.TAB_OTHER_FLIGHTS}`;
        }

        if (optionSelected && optionType) {
            if (optionType === 'SPECIAL_MEALS') {
                const { total } = this.model.flightSelected.menusSelected.filter(menu => menu.type === 'SPECIAL_MEALS')[0];
                const labelValue = total > 0
                    ? GASTRONOMIC_EVENT_LABEL_VALUES.SPECIAL_MEALS_SELECTED
                    : GASTRONOMIC_EVENT_LABEL_VALUES.SPECIAL_MEALS;
                eventLabel += `:${labelValue}`;
            } else {
                eventLabel += `:${GASTRONOMIC_EVENT_LABEL_VALUES[optionType]}`;
            }
        }
        return eventLabel;
    }

    private emitFlightTabSelected() {
        this.ibDigitalMenuService.updateFlightTabSelected(this.model.flightSelected);
    }

    private updateMenusSelected() {
        this.gastroProposalModel.flights.map(flight => {
            flight.menusSelected = this.ibSpecialMealsService.getMenusBySegment(flight.id);
        });
    }

    $onInit() {
        this.activate();
    }
}
